module.exports = __webpack_public_path__ + "sunsemweb/img/topLogo.00a5afed.png";